(() => {
  if (!customElements.get('hx-formula-finder')) customElements.define('hx-formula-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.dialog = this.querySelector('dialog');
      const options = { signal: this.abort.signal };
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      document.querySelectorAll('[data-hx-finder-open]').forEach(link => link.addEventListener('click', event => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.opener = link;
        this.dialog.showModal();
        this.dialog.querySelector('h2').focus({ preventScroll: true });
      }, options));
      this.querySelector('[data-finder-close]').addEventListener('click', () => this.close(), options);
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.close(); }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close();
      }, options);
      this.querySelectorAll('[data-finder-goal]').forEach(button => button.addEventListener('click', () => {
        const goal = button.dataset.finderGoal;
        this.querySelectorAll('[data-finder-goal]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        let count = 0;
        this.querySelectorAll('[data-finder-product]').forEach(card => {
          card.hidden = !card.dataset.finderGoals.split(/\s+/).includes(goal);
          if (!card.hidden) count++;
        });
        const priorities = {
          energy: ['nad-nicotinamide-riboside-chloride-300mg-boost-cellulaire', 'nadh-25mg-energie-cellulaire', 'nad-nicotinamide-riboside-chloride-powder'],
          sleep: ['zen-magnesium-bisglycinate-passiflore-l-tryptophane-taurine-vitamine-b6-anxiolytique-naturel', 'magtein-magnesium-l-threonate-90-gelules'],
          focus: ['magtein-magnesium-l-threonate-90-gelules', 'huperzine-a-100mcg-huperzia-serrata-focus-concentration-60-gelules'],
          antioxidant: ['glutathion-300mg-reduit', 'nac-n-acetylcysteine-600mg-antioxydant', 'resvegen-trans-resveratrol-98-labellise-resrox-60-gelules']
        };
        const order = priorities[goal] || [];
        const rank = card => { const index = order.indexOf(card.dataset.finderHandle); return index < 0 ? order.length : index; };
        const grid = this.querySelector('.hx-finder-grid');
        [...grid.children].sort((a, b) => rank(a) - rank(b)).forEach(card => grid.append(card));
        this.querySelector('[data-finder-results]').hidden = false;
        this.querySelector('[data-finder-empty]').hidden = count > 0;
        const heading = this.querySelector('.hx-finder-result-heading h3');
        heading.focus({ preventScroll: true });
        heading.scrollIntoView({ block: 'nearest', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, options));
    }
    close() { this.dialog.close(); this.opener?.focus({ preventScroll: true }); }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; if (this.dialog?.open) this.dialog.close(); }
  });
  let timer;
  const shopping = event => {
    if (!event.target.closest('.hx-product-form, .hx-product-sticky, .hx-collection-grid button, hx-range-carousel button[data-v3-add]')) return;
    document.documentElement.dataset.hxPurchaseIntent = 'true';
    document.dispatchEvent(new CustomEvent('hx:purchase-intent'));
    clearTimeout(timer);
    timer = setTimeout(() => { delete document.documentElement.dataset.hxPurchaseIntent; }, 30000);
  };
  document.addEventListener('pointerdown', shopping, { passive: true });
  document.addEventListener('focusin', shopping);
})();
